module.exports = __webpack_public_path__ + "static/media/galerija_2019 (12).2d7e60c9.jpg";